'use strict';

var RATE_OUTDOORS_CHATBOT_PATH = '/v2/rate-outdoors-chatbot';
var RATE_OUTDOORS_CHATBOT_ORIGIN = 'https://chatbot.prajnaapi.com';
var RATE_OUTDOORS_DEFAULT_MARK_SRC = 'https://cdn.shopify.com/s/files/1/0806/4525/9480/files/chatbot-icon.png?v=1782492562';
var RATE_OUTDOORS_LAUNCHER_MARK_SRC = 'https://cdn.shopify.com/s/files/1/0806/4525/9480/files/rate-outdoors-icon-black.svg?v=1782491986';

var RATE_OUTDOORS_FONT_STACK = "'Montserrat', sans-serif";
var RATE_OUTDOORS_FONT_STYLESHEET =
    'https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&display=swap';
var RATE_OUTDOORS_MIC_ICONS = {
    active: 'https://cdn.shopify.com/s/files/1/0806/4525/9480/files/mic-active.svg?v=1783089867',
    mute: 'https://cdn.shopify.com/s/files/1/0806/4525/9480/files/mic-mute.svg?v=1783089867',
};

var RATE_OUTDOORS_DEFAULT_THEME = {
    // Header bar — slate gradient (#32394F → #21292D)
    headerBgColor: '#E9EFF2',
    headerBgAccentColor: '#21292D',
    headerTitleColor: '#000000',
    headerStatusColor: '#80B0BF',
    headerIconColor: '#21292D',

    // Message bubbles
    queryMsgBgColor: 'linear-gradient(135deg, #32394F, #21292D)',
    queryMsgTextColor: '#ffffff',
    responseMsgBgColor: '#FAFBFC',
    responseMsgTextColor: '#2B2B2B',
    chatWindowBgColor: '#ffffff',

    // Footer style
    poweredByText: '#A3B9C4',

    // Voice overlay
    voicePanelBgColor: 'linear-gradient(160deg, #1C1D1D, #2B2B2B, #00617F)',

    // Composer input style (matches suggestion chips)
    inputBoxBgColor: '#FAFBFC',
    inputBoxTextColor: '#2B2B2B',
    inputBoxPlaceholderColor: '#797D7F',
    inputBoxBorderColor: '#E9EFF2',

    // Composer layout / hover (chips, input, send, mic, assistant bubble border)
    composerPadding: '16px',
    composerHoverBgColor: '#f2f6f7',
    composerHoverTextColor: '#000000',
    responseMsgBorderColor: '#E9EFF2',
    composerChipFontSize: '14px',

    chartColor: ['#2B2B2B', '#00617F', '#80B0BF', '#C4B08E', '#E7DED4'],

    // Typography (forwarded to the chatbot iframe so embedders can rebrand fonts).
    fontFamily: 'Montserrat, sans-serif',
    fontSizeBase: '14px',
    fontSizeTitle: '15px',
    fontSizeSmall: '12px',
    fontWeightBase: '500',
    fontWeightBold: '700',

    // Mic icons — parent shell header + iframe composer/voice mode.
    micIconActive: RATE_OUTDOORS_MIC_ICONS.active,
    micIconMute: RATE_OUTDOORS_MIC_ICONS.mute,

    // Suggestion chip shape (matches assistant bubble: 16px + 4px bottom-left notch).
    promptChipBorderRadius: '16px',
    promptChipCornerRadius: '4px',
};

var RATE_OUTDOORS_THEME = Object.assign({}, RATE_OUTDOORS_DEFAULT_THEME);

var RATE_OUTDOORS_AVATAR = {
    src: RATE_OUTDOORS_DEFAULT_MARK_SRC,
    alt: '',
};

var RATE_OUTDOORS_AVATAR_DEFAULT = {
    src: RATE_OUTDOORS_AVATAR.src,
    alt: RATE_OUTDOORS_AVATAR.alt,
};

var RATE_OUTDOORS_LAUNCHER_ICON_DEFAULT = {
    src: RATE_OUTDOORS_LAUNCHER_MARK_SRC,
    alt: 'Rate Outdoors',
};

var RATE_OUTDOORS_LAUNCHER_ICON = {
    src: RATE_OUTDOORS_LAUNCHER_ICON_DEFAULT.src,
    alt: RATE_OUTDOORS_LAUNCHER_ICON_DEFAULT.alt,
};

var RATE_OUTDOORS_EMBED = {
    clientId: 'rate-outdoors',
};

function getRateOutdoorsParentOrigin() {
    if (window.location && typeof window.location.origin === 'string' && window.location.origin) {
        return window.location.origin;
    }
    return 'null';
}

function getRateOutdoorsEmbedConfig() {
    return {
        clientId:
            RATE_OUTDOORS_EMBED && typeof RATE_OUTDOORS_EMBED.clientId === 'string'
                ? RATE_OUTDOORS_EMBED.clientId
                : 'rate-outdoors',
        parentOrigin: getRateOutdoorsParentOrigin(),
    };
}

function resolveImageSrcForIframe(src) {
    if (typeof src !== 'string' || !src.trim()) return '';
    var value = src.trim();
    if (/^(data:|blob:|https?:\/\/|\/\/)/i.test(value)) return value;

    // A file:// URL cannot be loaded by the hosted iframe. In that case the
    // child falls back to its bundled default avatar.
    if (window.location && window.location.protocol === 'file:') return '';

    try {
        return new URL(value, window.location.href).href;
    } catch (e) {
        return value;
    }
}

function resolveRateOutdoorsChatUrl() {
    var params = new URLSearchParams(window.location.search);
    var fromQuery = (params.get('chat') || params.get('url') || '').trim();
    var defaultChat = RATE_OUTDOORS_CHATBOT_ORIGIN.replace(/\/$/, '') + RATE_OUTDOORS_CHATBOT_PATH;
    return fromQuery || defaultChat;
}

var resolvedChatUrl = resolveRateOutdoorsChatUrl();

function withEmbedQuery(url) {
    try {
        var u = new URL(url);
        u.searchParams.set('embed', '1');
        return u.toString();
    } catch (e) {
        var sep = url.indexOf('?') >= 0 ? '&' : '?';
        return url + sep + 'embed=1';
    }
}

var resolvedIframeUrl = withEmbedQuery(resolvedChatUrl);

var expectedChatOrigin = '';
try {
    expectedChatOrigin = new URL(resolvedIframeUrl).origin;
} catch (e) {
    /* ignore */
}

var widgetMaximized = false;
var widgetCollapsed = false;

function postToIframe(payload) {
    var f = document.getElementById('chatbot-iframe');
    if (!f || !f.contentWindow) return;
    try {
        f.contentWindow.postMessage(payload, expectedChatOrigin || '*');
    } catch (err) {
        /* ignore */
    }
}

function postRateOutdoorsConfig() {
    var avatarSrc =
        RATE_OUTDOORS_AVATAR && typeof RATE_OUTDOORS_AVATAR.src === 'string' && RATE_OUTDOORS_AVATAR.src
            ? RATE_OUTDOORS_AVATAR.src
            : '';
    var iframeAvatarSrc = resolveImageSrcForIframe(avatarSrc);
    postToIframe({
        type: 'prajna-ratefit-config',
        theme: getRateOutdoorsChatbotTheme(),
        avatar: iframeAvatarSrc ? { src: iframeAvatarSrc } : null,
        embed: getRateOutdoorsEmbedConfig(),
    });
}

function getRateOutdoorsChatbotTheme() {
    var theme = RATE_OUTDOORS_THEME || {};
    var micActiveSrc =
        typeof theme.micIconActive === 'string' && theme.micIconActive
            ? theme.micIconActive
            : RATE_OUTDOORS_MIC_ICONS.active;
    var micMuteSrc =
        typeof theme.micIconMute === 'string' && theme.micIconMute
            ? theme.micIconMute
            : RATE_OUTDOORS_MIC_ICONS.mute;
    return {
        queryMsgBgColor: theme.queryMsgBgColor,
        queryMsgTextColor: theme.queryMsgTextColor,
        responseMsgBgColor: theme.responseMsgBgColor,
        responseMsgTextColor: theme.responseMsgTextColor,
        chatWindowBgColor: theme.chatWindowBgColor,
        poweredByText: theme.poweredByText,
        voicePanelBgColor: theme.voicePanelBgColor,
        inputBoxBgColor: theme.inputBoxBgColor,
        inputBoxTextColor: theme.inputBoxTextColor,
        inputBoxPlaceholderColor: theme.inputBoxPlaceholderColor,
        inputBoxBorderColor: theme.inputBoxBorderColor,
        composerPadding: theme.composerPadding,
        composerHoverBgColor: theme.composerHoverBgColor,
        composerHoverTextColor: theme.composerHoverTextColor,
        responseMsgBorderColor: theme.responseMsgBorderColor,
        composerChipFontSize: theme.composerChipFontSize,
        chartColor: theme.chartColor,
        fontFamily: theme.fontFamily,
        fontSizeBase: theme.fontSizeBase,
        fontSizeTitle: theme.fontSizeTitle,
        fontSizeSmall: theme.fontSizeSmall,
        fontWeightBase: theme.fontWeightBase,
        fontWeightBold: theme.fontWeightBold,
        micIconActiveUrl: resolveImageSrcForIframe(micActiveSrc),
        micIconMuteUrl: resolveImageSrcForIframe(micMuteSrc),
    };
}

function getRateOutdoorsAvatarSrc() {
    return RATE_OUTDOORS_AVATAR && typeof RATE_OUTDOORS_AVATAR.src === 'string' && RATE_OUTDOORS_AVATAR.src
        ? RATE_OUTDOORS_AVATAR.src
        : RATE_OUTDOORS_AVATAR_DEFAULT.src;
}

function getRateOutdoorsAvatarAlt() {
    return RATE_OUTDOORS_AVATAR && typeof RATE_OUTDOORS_AVATAR.alt === 'string'
        ? RATE_OUTDOORS_AVATAR.alt
        : RATE_OUTDOORS_AVATAR_DEFAULT.alt;
}

function parseColorToRgb(input) {
    if (typeof input !== 'string') return null;
    var s = input.trim();
    if (!s) return null;
    if (s.charAt(0) === '#') {
        var hex = s.slice(1);
        if (hex.length === 3) {
            hex = hex.charAt(0) + hex.charAt(0) + hex.charAt(1) + hex.charAt(1) + hex.charAt(2) + hex.charAt(2);
        }
        if (hex.length !== 6 || /[^0-9a-fA-F]/.test(hex)) return null;
        return {
            r: parseInt(hex.slice(0, 2), 16),
            g: parseInt(hex.slice(2, 4), 16),
            b: parseInt(hex.slice(4, 6), 16),
        };
    }
    var m = s.match(/^rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/i);
    if (m) {
        return { r: parseInt(m[1], 10), g: parseInt(m[2], 10), b: parseInt(m[3], 10) };
    }
    return null;
}

function rgbaFromColor(color, alpha) {
    var rgb = parseColorToRgb(color);
    if (!rgb) return null;
    return 'rgba(' + rgb.r + ', ' + rgb.g + ', ' + rgb.b + ', ' + alpha + ')';
}

function getThemeString(key) {
    var current = RATE_OUTDOORS_THEME || {};
    if (typeof current[key] === 'string' && current[key]) return current[key];
    return RATE_OUTDOORS_DEFAULT_THEME[key];
}

function applyShellTheme() {
    var root = document.documentElement;
    if (!root || !root.style) return;

    var headerBgColor = getThemeString('headerBgColor');
    var headerBgAccentColor = getThemeString('headerBgAccentColor');

    root.style.setProperty('--rf-shell-primary', headerBgColor);
    root.style.setProperty('--rf-shell-primary-dark', headerBgAccentColor);
    root.style.setProperty('--rf-shell-title', getThemeString('headerTitleColor'));
    root.style.setProperty('--rf-shell-status', getThemeString('headerStatusColor'));
    root.style.setProperty('--rf-shell-icon', getThemeString('headerIconColor'));
    root.style.setProperty(
        '--rf-shell-gradient',
        headerBgColor
    );

    var glow = rgbaFromColor(headerBgColor, 0.35);
    var glowStrong = rgbaFromColor(headerBgColor, 0.4);
    if (glow) root.style.setProperty('--rf-shell-glow', glow);
    if (glowStrong) root.style.setProperty('--rf-shell-glow-strong', glowStrong);

    ensureFontStylesheet(getThemeString('fontStylesheetHref'));
}

function ensureFontStylesheet(href) {
    if (typeof href !== 'string' || !href.trim()) return;
    var value = href.trim();
    if (document.querySelector('link[data-rate-outdoors-font="' + value + '"]')) return;
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = value;
    link.setAttribute('data-rate-outdoors-font', value);
    document.head.appendChild(link);
}

function getRateOutdoorsMicIconSrc(kind) {
    var current = RATE_OUTDOORS_THEME || {};
    var key = kind === 'mute' ? 'micIconMute' : 'micIconActive';
    var fallback = kind === 'mute' ? RATE_OUTDOORS_MIC_ICONS.mute : RATE_OUTDOORS_MIC_ICONS.active;
    var src =
        typeof current[key] === 'string' && current[key] ? current[key] : fallback;
    try {
        return new URL(src, window.location.href).href;
    } catch (e) {
        return src;
    }
}

function applyLauncherIcon() {
    var img = document.getElementById('rf-launcher-img');
    if (!img) return;
    var src =
        RATE_OUTDOORS_LAUNCHER_ICON && typeof RATE_OUTDOORS_LAUNCHER_ICON.src === 'string' && RATE_OUTDOORS_LAUNCHER_ICON.src
            ? RATE_OUTDOORS_LAUNCHER_ICON.src
            : RATE_OUTDOORS_LAUNCHER_ICON_DEFAULT.src;
    var alt =
        RATE_OUTDOORS_LAUNCHER_ICON && typeof RATE_OUTDOORS_LAUNCHER_ICON.alt === 'string'
            ? RATE_OUTDOORS_LAUNCHER_ICON.alt
            : RATE_OUTDOORS_LAUNCHER_ICON_DEFAULT.alt;
    if (img.getAttribute('src') !== src) {
        img.setAttribute('src', src);
    }
    img.setAttribute('alt', alt);
}

function applyHeaderAvatar() {
    var img = document.getElementById('rf-header-avatar-img');
    if (!img) return;
    var src = getRateOutdoorsAvatarSrc();
    var alt = getRateOutdoorsAvatarAlt();
    if (img.getAttribute('src') !== src) {
        img.setAttribute('src', src);
    }
    img.setAttribute('alt', alt);
}

function shellOpenVoice() {
    postToIframe({ type: 'prajna-ratefit-action', action: 'voice' });
}

function shellToggleMaximize() {
    if (!chatbotWidget || !chatbotWidget.classList.contains('active')) return;
    if (widgetCollapsed) {
        chatbotWidget.classList.add('rf-no-transition');
        chatbotWidget.classList.remove('rf-widget--collapsed');
        widgetCollapsed = false;

        chatbotWidget.classList.remove('rf-widget--maximized');
        widgetMaximized = false;

        requestAnimationFrame(function () {
            if (!chatbotWidget) return;
            chatbotWidget.classList.remove('rf-no-transition');
        });
        return;
    }
    widgetMaximized = !widgetMaximized;
    chatbotWidget.classList.toggle('rf-widget--maximized', widgetMaximized);
}

function shellMinimizeWidget() {
    if (!chatbotWidget) return;
    if (isMinimized) return;

    if (chatbotWidget.classList.contains('rf-widget--maximized')) {
        chatbotWidget.classList.remove('rf-widget--maximized');
        widgetMaximized = false;
    }
    widgetCollapsed = !widgetCollapsed;
    chatbotWidget.classList.toggle('rf-widget--collapsed', widgetCollapsed);
}

function shellCloseWidget() {
    if (isMinimized) return;

    isMinimized = true;

    if (chatbotWidget) chatbotWidget.classList.remove('active');
    if (chatbotGetter) chatbotGetter.classList.remove('hidden');
    if (launcherButton) launcherButton.setAttribute('aria-expanded', 'false');

    setTimeout(function () {
        if (chatbotWidget) {
            chatbotWidget.classList.remove('rf-widget--maximized');
            chatbotWidget.classList.remove('rf-widget--collapsed');
        }
        widgetMaximized = false;
        widgetCollapsed = false;
    }, 350);
}

function applyShellStreamingState(streaming) {
    var dot = document.getElementById('rf-chat-status-dot');
    var label = document.getElementById('rf-chat-status-label');
    if (label) {
        label.textContent = streaming ? 'Typing…' : 'Online';
    }
    if (dot) {
        if (streaming) {
            dot.classList.add('rf-status-dot--typing');
        } else {
            dot.classList.remove('rf-status-dot--typing');
        }
    }
}

window.addEventListener('message', function (event) {
    var d = event.data;
    if (!d || d.type !== 'prajna-ratefit-status') return;
    if (expectedChatOrigin && event.origin !== expectedChatOrigin) return;
    applyShellStreamingState(!!d.streaming);
});

let isMinimized = true;
const chatbotGetter = document.getElementById('chatbot-getter');
const loadingIndicator = document.getElementById('loading');
const iframe = document.getElementById('chatbot-iframe');
const chatbotWidget = document.getElementById('chatbot-widget');
const launcherButton = document.getElementById('rf-launcher-button');
const voiceButton = document.getElementById('rf-action-voice');
const maximizeButton = document.getElementById('rf-action-maximize');
const minimizeButton = document.getElementById('rf-action-minimize');
const closeButton = document.getElementById('rf-action-close');

function toggleChatbot() {
    isMinimized = !isMinimized;

    if (isMinimized && chatbotWidget) {
        chatbotWidget.classList.remove('rf-widget--maximized');
        widgetMaximized = false;
        chatbotWidget.classList.remove('rf-widget--collapsed');
        widgetCollapsed = false;
    }
    if (!isMinimized && chatbotWidget) {
        chatbotWidget.classList.remove('rf-widget--collapsed');
        widgetCollapsed = false;
    }
    if (chatbotWidget) chatbotWidget.classList.toggle('active');
    if (chatbotGetter) chatbotGetter.classList.toggle('hidden');
    if (launcherButton) launcherButton.setAttribute('aria-expanded', String(!isMinimized));
}

function showLoading() {
    if (loadingIndicator) loadingIndicator.style.display = 'block';
}

function hideLoading() {
    if (loadingIndicator) loadingIndicator.style.display = 'none';
}

function bindClick(element, handler) {
    if (element) element.addEventListener('click', handler);
}

bindClick(launcherButton, toggleChatbot);
bindClick(voiceButton, shellOpenVoice);
bindClick(maximizeButton, shellToggleMaximize);
bindClick(minimizeButton, shellMinimizeWidget);
bindClick(closeButton, shellCloseWidget);

if (iframe) {
    iframe.onload = function () {
        hideLoading();
        applyShellStreamingState(false);
        if (chatbotWidget) {
            chatbotWidget.classList.remove('rf-widget--maximized');
            widgetMaximized = false;
            chatbotWidget.classList.remove('rf-widget--collapsed');
            widgetCollapsed = false;
        }
        if (!isMinimized && loadingIndicator) {
            loadingIndicator.style.display = 'none';
        }
        postRateOutdoorsConfig();
    };
    iframe.src = resolvedIframeUrl;
}
window.addEventListener('message', function (event) {
    var d = event.data;
    if (!d || d.type !== 'prajna-ratefit-ready') return;
    if (expectedChatOrigin && event.origin !== expectedChatOrigin) return;
    postRateOutdoorsConfig();
});

window.PrajnaChatWidget = {
    setTheme: function (partialTheme) {
        if (partialTheme && typeof partialTheme === 'object') {
            RATE_OUTDOORS_THEME = Object.assign({}, RATE_OUTDOORS_THEME || {}, partialTheme);
        } else {
            RATE_OUTDOORS_THEME = Object.assign({}, RATE_OUTDOORS_DEFAULT_THEME);
        }
        applyShellTheme();
        postRateOutdoorsConfig();
    },
    resetTheme: function () {
        RATE_OUTDOORS_THEME = Object.assign({}, RATE_OUTDOORS_DEFAULT_THEME);
        applyShellTheme();
        postRateOutdoorsConfig();
    },
    setAvatar: function (srcOrObj) {
        if (!srcOrObj) {
            RATE_OUTDOORS_AVATAR = Object.assign({}, RATE_OUTDOORS_AVATAR_DEFAULT);
        } else if (typeof srcOrObj === 'string') {
            RATE_OUTDOORS_AVATAR = { src: srcOrObj, alt: RATE_OUTDOORS_AVATAR.alt || '' };
        } else if (typeof srcOrObj === 'object') {
            var avatarSrc =
                typeof srcOrObj.src === 'string' && srcOrObj.src
                    ? srcOrObj.src
                    : RATE_OUTDOORS_AVATAR.src;
            var avatarAlt =
                typeof srcOrObj.alt === 'string'
                    ? srcOrObj.alt
                    : RATE_OUTDOORS_AVATAR.alt || '';
            RATE_OUTDOORS_AVATAR = { src: avatarSrc, alt: avatarAlt };
        }
        applyHeaderAvatar();
        postRateOutdoorsConfig();
    },
    setLauncherIcon: function (srcOrObj) {
        if (!srcOrObj) {
            RATE_OUTDOORS_LAUNCHER_ICON = {
                src: RATE_OUTDOORS_LAUNCHER_ICON_DEFAULT.src,
                alt: RATE_OUTDOORS_LAUNCHER_ICON_DEFAULT.alt,
            };
        } else if (typeof srcOrObj === 'string') {
            RATE_OUTDOORS_LAUNCHER_ICON = { src: srcOrObj, alt: RATE_OUTDOORS_LAUNCHER_ICON.alt || '' };
        } else if (typeof srcOrObj === 'object') {
            var nextSrc =
                typeof srcOrObj.src === 'string' && srcOrObj.src
                    ? srcOrObj.src
                    : RATE_OUTDOORS_LAUNCHER_ICON.src;
            var nextAlt =
                typeof srcOrObj.alt === 'string'
                    ? srcOrObj.alt
                    : RATE_OUTDOORS_LAUNCHER_ICON.alt || '';
            RATE_OUTDOORS_LAUNCHER_ICON = { src: nextSrc, alt: nextAlt };
        }
        applyLauncherIcon();
    },
    setClientId: function (clientId) {
        if (typeof clientId === 'string' && clientId.trim()) {
            RATE_OUTDOORS_EMBED.clientId = clientId.trim();
            postRateOutdoorsConfig();
        }
    },
    open: function () {
        if (isMinimized) toggleChatbot();
    },
    close: function () {
        if (!isMinimized) shellCloseWidget();
    },
    toggle: function () {
        toggleChatbot();
    },
    reload: function () {
        reloadChat();
    },
};

function reloadChat() {
    if (chatbotWidget) {
        chatbotWidget.classList.remove('rf-widget--maximized');
        widgetMaximized = false;
    }
    if (iframe) {
        iframe.src = resolvedIframeUrl;
    }
    showLoading();
}

applyShellTheme();
applyLauncherIcon();
applyHeaderAvatar();
showLoading();
